import _map from "lodash/map";
import _size from "lodash/size";
import _round from "lodash/round";
import * as React from 'react';
import Droppable from '../Droppable';
import TasksArea from '../TasksArea';
import { jsx as ___EmotionJSX } from "@emotion/react";
const TASKS_AREA_WIDTH = "".concat(100 / 3, "%");
const ClassifyLists = _ref => {
  let {
    groupedItems,
    orderGroupedItems,
    setItemOffset,
    targets
  } = _ref;
  const [firstTarget, ...restTargets] = targets;
  const width = "".concat(_round(100 / _size(restTargets)) + 1, "%");
  return ___EmotionJSX("div", {
    className: "dc-u-fx dc-u-fx-fdc dc-u-w-100pc dc-u-h-100pc dc-u-bgc-grey-100 dc-u-of-auto"
  }, ___EmotionJSX(TasksArea, {
    droppableId: firstTarget.id,
    groupedItems: groupedItems,
    items: groupedItems[firstTarget.id],
    key: firstTarget.id,
    languageOfTarget: firstTarget.language,
    maxOffset: firstTarget.maxOffset,
    orderGroupedItems: orderGroupedItems,
    setItemOffset: setItemOffset,
    targets: targets,
    width: TASKS_AREA_WIDTH
  }), ___EmotionJSX("div", {
    className: "dc-u-ifx dc-u-h-100pc dc-u-mt-16"
  }, _map(restTargets, _ref2 => {
    let {
      id,
      language: languageOfTarget,
      maxOffset,
      title
    } = _ref2;
    return ___EmotionJSX("div", {
      key: id,
      style: {
        height: '100%',
        width
      }
    }, ___EmotionJSX(Droppable, {
      droppableId: id,
      extraClass: "dc-u-h-100pc",
      items: groupedItems[id],
      key: id,
      languageOfTarget: languageOfTarget,
      maxOffset: maxOffset,
      setItemOffset: setItemOffset,
      title: ___EmotionJSX("h5", {
        className: "dc-u-ta-center"
      }, title)
    }));
  })));
};
export default ClassifyLists;